import script from "./computePart.vue?vue&type=script&setup=true&lang=js"
export * from "./computePart.vue?vue&type=script&setup=true&lang=js"

import "./computePart.vue?vue&type=style&index=0&id=29958d55&lang=css"

const __exports__ = script;

export default __exports__